<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="星级" >
        <a-select v-model="form.grade" placeholder="请选择星级" @change="changeStatus">
          <a-select-option :value="0">无</a-select-option>
          <a-select-option :value="1">一星</a-select-option>
          <a-select-option :value="2">二星</a-select-option>
          <a-select-option :value="3">三星</a-select-option>
          <a-select-option :value="4">四星</a-select-option>
          <a-select-option :value="5">五星</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="报名截至时间" >
        <a-input v-model="form.endSignTime" placeholder="报名截至时间（YYYY-MM-DD HH:mm:ss）" />
      </a-form-model-item>
      <a-form-model-item label="赛事截至时间" >
        <a-input v-model="form.endFinalTime" placeholder="赛事截至时间（YYYY-MM-DD HH:mm:ss）" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getCompetition, setGrade} from '@/api/platform/competition'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      showVer: false,
      // 表单参数
      form: {
        id: null,
        grade: null,
        endSignTime: null,
        endFinalTime: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    changeStatus(status){
      if(status == 1){
        this.showVer = false;
      }
      if(status == 2){
        this.showVer = true;
      }
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        grade: null,
        endSignTime: null,
        endFinalTime: null
      }
     /* this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })*/
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCompetition({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            setGrade(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            setGrade(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
